export interface Comic {
  id: string;
  title: string;
  genre: string;
  tagline: string;
  author: string;
  status: string;
  rating: number;
  followers: number;
  chapters: number;
  image: string;
  badge?: string;
}

export interface Booklist {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  tags: string[];
  image: string;
  count: number;
  editor: string;
}

export interface Category {
  id: string;
  name: string;
  desc: string;
  count: number;
  icon: string;
}

export interface Testimonial {
  id: string;
  name: string;
  role: string;
  content: string;
  avatar: string;
}

export interface Faq {
  id: string;
  q: string;
  a: string;
}

export const featuredComics: Comic[] = [
  {
    id: 'c1',
    title: '月下剑鸣',
    genre: '热血战斗',
    tagline: '少年持刀，问鼎九霄，一场跨越三界的宿命之战。',
    author: '北川一郎',
    status: '连载中',
    rating: 9.6,
    followers: 128000,
    chapters: 386,
    badge: '编辑推荐',
    image: 'https://readdy.ai/api/search-image?query=young%20swordsman%20holding%20a%20glowing%20katana%20standing%20before%20a%20giant%20crimson%20moon%2C%20dark%20fantasy%20anime%20comic%20cover%2C%20bold%20orange%20and%20black%20flat%20colors%2C%20dynamic%20pose%2C%20dramatic%20lighting%2C%20clean%20simple%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=cover-01-x1&orientation=portrait',
  },
  {
    id: 'c2',
    title: '星屑图书馆',
    genre: '奇幻冒险',
    tagline: '一名少女图书管理员，翻开能唤醒世界记忆的古老书册。',
    author: '林晚枫',
    status: '连载中',
    rating: 9.4,
    followers: 96000,
    chapters: 217,
    badge: '编辑推荐',
    image: 'https://readdy.ai/api/search-image?query=female%20magician%20casting%20a%20swirling%20spell%20surrounded%20by%20floating%20open%20books%2C%20warm%20golden%20magical%20glow%2C%20fantasy%20anime%20comic%20cover%2C%20vibrant%20yellow%20and%20amber%20palette%2C%20clean%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=cover-02-x1&orientation=portrait',
  },
  {
    id: 'c3',
    title: '霓虹猎手',
    genre: '科幻赛博',
    tagline: '在钢筋霓虹之间穿行，她是最快的一把刀。',
    author: '苏子夜',
    status: '连载中',
    rating: 9.3,
    followers: 112000,
    chapters: 152,
    badge: '本周黑马',
    image: 'https://readdy.ai/api/search-image?query=cyberpunk%20bounty%20hunter%20standing%20on%20a%20neon%20rooftop%20above%20a%20rainy%20city%20at%20night%2C%20teal%20and%20magenta%20neon%20highlights%2C%20sci-fi%20anime%20comic%20cover%2C%20dark%20atmosphere%2C%20clean%20simple%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=cover-03-x1&orientation=portrait',
  },
  {
    id: 'c4',
    title: '深夜食堂喵',
    genre: '治愈日常',
    tagline: '一只会做拉面的猫掌柜，为你端上暖暖的夜宵。',
    author: '白桃乌龙',
    status: '连载中',
    rating: 9.7,
    followers: 150000,
    chapters: 298,
    badge: '口碑神作',
    image: 'https://readdy.ai/api/search-image?query=cute%20cat%20chef%20in%20a%20cozy%20warm%20kitchen%20preparing%20a%20steaming%20bowl%20of%20ramen%2C%20wholesome%20healing%20anime%20comic%20cover%2C%20soft%20pastel%20warm%20tones%2C%20gentle%20lighting%2C%20clean%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=cover-04-x1&orientation=portrait',
  },
  {
    id: 'c5',
    title: '机甲少年梦',
    genre: '机战热血',
    tagline: '放学后，他悄悄登上那架属于未来的巨型机甲。',
    author: '陈星野',
    status: '连载中',
    rating: 9.2,
    followers: 88000,
    chapters: 174,
    badge: '人气飙升',
    image: 'https://readdy.ai/api/search-image?query=high%20school%20student%20in%20uniform%20standing%20before%20a%20giant%20robot%20silhouette%20under%20a%20bright%20blue%20sky%2C%20mecha%20anime%20comic%20cover%2C%20bold%20energetic%20colors%2C%20dynamic%20composition%2C%20clean%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=cover-05-x1&orientation=portrait',
  },
  {
    id: 'c6',
    title: '御剑问仙',
    genre: '仙侠修真',
    tagline: '凡人李青一柄桃木剑，踏破九重天。',
    author: '云中客',
    status: '已完结',
    rating: 9.5,
    followers: 203000,
    chapters: 512,
    image: 'https://readdy.ai/api/search-image?query=ancient%20cultivator%20flying%20on%20a%20sword%20through%20clouds%20above%20misty%20mountains%2C%20jade%20green%20and%20gold%20palette%2C%20xianxia%20wuxia%20comic%20cover%2C%20ethereal%20atmosphere%2C%20clean%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=cover-06-x1&orientation=portrait',
  },
];

export const hotComics: Comic[] = [
  {
    id: 'h1',
    title: '雪夜剑客',
    genre: '热血战斗',
    tagline: '独行剑客踏入冰封小镇，旧怨与新仇在此终结。',
    author: '青山影',
    status: '连载中',
    rating: 9.3,
    followers: 89000,
    chapters: 96,
    image: 'https://readdy.ai/api/search-image?query=lonely%20swordsman%20walking%20through%20a%20snowy%20bamboo%20forest%2C%20cool%20blue-grey%20tones%2C%20wuxia%20anime%20comic%20cover%2C%20melancholic%20atmosphere%2C%20clean%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=cover-07-x1&orientation=portrait',
  },
  {
    id: 'h2',
    title: '云端速递员',
    genre: '奇幻冒险',
    tagline: '骑着单车穿梭云上浮城，替远方的思念送达包裹。',
    author: '米粒团团',
    status: '连载中',
    rating: 9.1,
    followers: 74000,
    chapters: 130,
    image: 'https://readdy.ai/api/search-image?query=delivery%20girl%20riding%20a%20bicycle%20through%20a%20fantasy%20floating%20city%20in%20the%20sky%2C%20warm%20sunset%20colors%2C%20whimsical%20anime%20comic%20cover%2C%20adventurous%20mood%2C%20clean%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=cover-08-x1&orientation=portrait',
  },
  {
    id: 'h3',
    title: '血族爵府',
    genre: '奇幻恋爱',
    tagline: '误入古堡的少女，与沉睡百年的吸血鬼伯爵相遇。',
    author: '蔷薇之刃',
    status: '连载中',
    rating: 9.0,
    followers: 102000,
    chapters: 88,
    image: 'https://readdy.ai/api/search-image?query=vampire%20count%20in%20a%20grand%20dark%20library%20with%20red%20candles%20and%20old%20bookshelves%2C%20gothic%20romance%20anime%20comic%20cover%2C%20deep%20red%20and%20black%20palette%2C%20elegant%20mood%2C%20clean%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=cover-09-x1&orientation=portrait',
  },
  {
    id: 'h4',
    title: '星光练习生',
    genre: '偶像励志',
    tagline: '聚光灯亮起，属于她的舞台才刚刚开始。',
    author: '盛夏光年',
    status: '连载中',
    rating: 9.2,
    followers: 118000,
    chapters: 120,
    image: 'https://readdy.ai/api/search-image?query=idol%20girl%20performing%20on%20a%20colorful%20concert%20stage%20with%20fans%20holding%20glowing%20lightsticks%2C%20bright%20dynamic%20anime%20comic%20cover%2C%20vibrant%20stage%20lights%2C%20clean%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=cover-10-x1&orientation=portrait',
  },
  {
    id: 'h5',
    title: '迷雾侦探社',
    genre: '悬疑推理',
    tagline: '霓虹雨夜里，她用一枚放大镜拆解谜题。',
    author: '孤舟蓑笠',
    status: '连载中',
    rating: 9.4,
    followers: 96000,
    chapters: 77,
    image: 'https://readdy.ai/api/search-image?query=young%20detective%20holding%20a%20magnifying%20glass%20on%20a%20rain-soaked%20neon%20street%20at%20night%2C%20mystery%20noir%20anime%20comic%20cover%2C%20cool%20blue%20and%20amber%20tones%2C%20suspenseful%20mood%2C%20clean%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=cover-11-x1&orientation=portrait',
  },
  {
    id: 'h6',
    title: '鲸岛漂流记',
    genre: '冒险治愈',
    tagline: '搁浅在巨鲸背上的小岛，少年开始了他的漂流。',
    author: '珊瑚海',
    status: '连载中',
    rating: 9.1,
    followers: 68000,
    chapters: 64,
    image: 'https://readdy.ai/api/search-image?query=boy%20standing%20on%20a%20small%20island%20on%20the%20back%20of%20a%20friendly%20giant%20sea%20turtle%20in%20a%20clear%20teal%20ocean%2C%20adventure%20healing%20anime%20comic%20cover%2C%20bright%20tropical%20colors%2C%20clean%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=cover-12-x1&orientation=portrait',
  },
  {
    id: 'h7',
    title: '星舰引航员',
    genre: '科幻太空',
    tagline: '穿越星云，为迷失的舰队寻找回家的航向。',
    author: '夜航星',
    status: '连载中',
    rating: 9.0,
    followers: 72000,
    chapters: 109,
    image: 'https://readdy.ai/api/search-image?query=space%20explorer%20in%20a%20mech%20suit%20gazing%20at%20a%20colorful%20nebulae%20through%20a%20spaceship%20window%2C%20sci-fi%20anime%20comic%20cover%2C%20deep%20space%20colors%20with%20violet%20and%20cyan%20glow%2C%20clean%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=cover-13-x1&orientation=portrait',
  },
  {
    id: 'h8',
    title: '食战巅峰',
    genre: '美食竞技',
    tagline: '两把菜刀，一场炉火，谁才是真正的厨神？',
    author: '胡椒小厨',
    status: '已完结',
    rating: 9.3,
    followers: 145000,
    chapters: 230,
    image: 'https://readdy.ai/api/search-image?query=cooking%20duel%20between%20two%20chefs%20with%20flames%20and%20flying%20ingredients%20in%20a%20kitchen%20arena%2C%20warm%20dynamic%20anime%20comic%20cover%2C%20energetic%20composition%2C%20bold%20red%20and%20gold%20colors%2C%20clean%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=cover-14-x1&orientation=portrait',
  },
];

export const booklists: Booklist[] = [
  {
    id: 'b1',
    title: '漫漫长夜·治愈书单',
    subtitle: '窝在被窝里一口气看完的暖心佳作',
    description: '白天忙到爆炸，晚上只想被温柔治愈。这份书单收录了编辑部私藏的暖心日常与成长故事，读完嘴角会不自觉上扬。',
    tags: ['治愈', '日常', '成长'],
    image: 'https://readdy.ai/api/search-image?query=stack%20of%20manga%20volumes%20and%20a%20steaming%20warm%20cup%20of%20tea%20on%20a%20cozy%20wooden%20desk%20beside%20a%20warm%20lamp%2C%20relaxing%20reading%20mood%2C%20editorial%20illustration%2C%20warm%20golden%20lighting%2C%20soft%20colors%2C%20high%20detail&width=900&height=500&seq=booklist-01-x1&orientation=landscape',
  },
  {
    id: 'b2',
    title: '热血燃向·追更首选',
    subtitle: '本周最值得蹲更新的连载黑马',
    description: '打斗燃到起鸡皮疙瘩、剧情跌宕起伏，编辑部本周强推的连载黑马全在这，收藏这份书单，追更不迷路。',
    tags: ['热血', '连载', '黑马'],
    image: 'https://readdy.ai/api/search-image?query=open%20comic%20book%20pages%20with%20colorful%20dynamic%20characters%20leaping%20out%20in%20an%20explosion%20of%20energy%2C%20imaginative%20editorial%20illustration%2C%20vibrant%20bold%20colors%2C%20dynamic%20motion%2C%20high%20detail&width=900&height=500&seq=booklist-02-x1&orientation=landscape',
  },
  {
    id: 'b3',
    title: '通勤路上的五分钟漫画',
    subtitle: '地铁里的碎片时间也能追的短篇',
    description: '单话五分钟内读完的短篇精选，节奏轻快、信息量刚刚好。适合通勤路上、午休间隙，随时随地打开就追。',
    tags: ['短篇', '轻松', '碎片时间'],
    image: 'https://readdy.ai/api/search-image?query=night%20reading%20lamp%20over%20an%20open%20manga%20next%20to%20a%20smartphone%20showing%20notification%20icons%2C%20cozy%20commute%20reading%20mood%2C%20editorial%20illustration%2C%20warm%20ambient%20light%2C%20high%20detail&width=900&height=500&seq=booklist-03-x1&orientation=landscape',
  },
  {
    id: 'b4',
    title: '神作补完计划',
    subtitle: '不看会后悔的完结口碑神作',
    description: '编辑部反复回看的完结神作，剧情完整、画工在线、结局圆满。假期想一口气补完，跟着这份书单走就对了。',
    tags: ['神作', '完结', '必看'],
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20colorful%20bookmarks%20and%20sparkling%20icons%20floating%20above%20a%20relaxing%20hot%20spring%20scene%20with%20steam%2C%20retreat%20and%20binge-reading%20mood%2C%20editorial%20illustration%2C%20soothing%20warm%20colors%2C%20high%20detail&width=900&height=500&seq=booklist-04-x1&orientation=landscape',
  },
];

export const categories: Category[] = [
  { id: 'cat1', name: '热血战斗', desc: '拳拳到肉，燃到起飞', count: 1240, icon: 'ri-flashlight-fill' },
  { id: 'cat2', name: '治愈日常', desc: '暖暖的，刚刚好', count: 986, icon: 'ri-sun-fill' },
  { id: 'cat3', name: '奇幻冒险', desc: '世界尽头还有世界', count: 1120, icon: 'ri-compass-3-fill' },
  { id: 'cat4', name: '悬疑推理', desc: '真相永远不止一层', count: 760, icon: 'ri-search-eye-fill' },
  { id: 'cat5', name: '科幻赛博', desc: '未来已来，何必等待', count: 534, icon: 'ri-rocket-2-fill' },
  { id: 'cat6', name: '恋爱青春', desc: '心跳的每一帧', count: 843, icon: 'ri-heart-3-fill' },
  { id: 'cat7', name: '仙侠修真', desc: '御剑乘风，快意恩仇', count: 690, icon: 'ri-knife-blood-fill' },
  { id: 'cat8', name: '美食竞技', desc: '色香味俱全的对决', count: 312, icon: 'ri-restaurant-fill' },
];

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    name: '小鱼干',
    role: '追漫 3 年',
    content: '以前找漫画要翻好几页榜单，现在每天打开香蕉漫画社，编辑精选已经帮我筛好了，直接开追，省下好多时间。',
    avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20anime-style%20avatar%20portrait%2C%20smiling%20warmly%2C%20shoulder-length%20hair%2C%20friendly%20expression%2C%20flat%20simple%20warm%20background%2C%20clean%20digital%20illustration&width=200&height=200&seq=avatar-01-x1&orientation=squarish',
  },
  {
    id: 't2',
    name: '夜航者',
    role: '追漫 5 年',
    content: '《月下剑鸣》就是从这里发现的！编辑的眼光很准，每周更新的书单都踩在我的兴趣点上，追更提醒也很贴心。',
    avatar: 'https://readdy.ai/api/search-image?query=young%20man%20anime-style%20avatar%20portrait%20wearing%20glasses%2C%20friendly%20confident%20smile%2C%20flat%20simple%20warm%20background%2C%20clean%20digital%20illustration&width=200&height=200&seq=avatar-02-x1&orientation=squarish',
  },
  {
    id: 't3',
    name: '阿柴不困',
    role: '睡前漫画爱好者',
    content: '治愈书单简直是睡前救星，编辑部选的日常漫又暖又不拖沓，我已经把这份书单收藏并推荐给室友了。',
    avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20anime-style%20avatar%20portrait%20with%20short%20bob%20haircut%2C%20cheerful%20expression%2C%20flat%20simple%20warm%20background%2C%20clean%20digital%20illustration&width=200&height=200&seq=avatar-03-x1&orientation=squarish',
  },
  {
    id: 't4',
    name: '青柠汽水',
    role: '神作收藏家',
    content: '“神作补完计划”让我在假期补完了好几部口碑大作，书单里的介绍写得走心，不是那种干巴巴的评分罗列。',
    avatar: 'https://readdy.ai/api/search-image?query=young%20man%20anime-style%20avatar%20portrait%20with%20casual%20relaxed%20smile%2C%20flat%20simple%20warm%20background%2C%20clean%20digital%20illustration&width=200&height=200&seq=avatar-04-x1&orientation=squarish',
  },
];

export const faqs: Faq[] = [
  {
    id: 'f1',
    q: '香蕉漫画社的编辑推荐和普通榜单有什么区别？',
    a: '普通榜单只按热度机械排序，而香蕉漫画社的编辑推荐由资深漫画编辑人工筛选。我们会综合剧情完成度、画风、更新稳定度和读者反馈来挑选，帮你过滤掉低质注水内容，每天更新一份值得追的精选书单。',
  },
  {
    id: 'f2',
    q: '如何快速找到适合自己口味的漫画？',
    a: '你可以通过首页的“主题分类”模块按热血、治愈、悬疑等口味快速筛选，也可以直接浏览每日更新的精选书单。每个书单都有清晰的主题和简介，点开即可了解适不适合你。',
  },
  {
    id: 'f3',
    q: '编辑推荐的漫画支持追更提醒吗？',
    a: '支持。收藏你喜欢的漫画后，可在个人收藏中开启追更提醒，新话更新时会第一时间通知你，再也不用担心错过每周的更新。',
  },
  {
    id: 'f4',
    q: '神作补完计划里的漫画都是完结作品吗？',
    a: '是的。“神作补完计划”收录的都是剧情完整、已完结的口碑佳作，适合想一口气补完、不想追连载的读者。书单里也标注了话数和完结状态，方便你规划阅读时间。',
  },
  {
    id: 'f5',
    q: '网站上的漫画内容可以免费阅读吗？',
    a: '香蕉漫画社是编辑推荐信息门户，提供的是精选书单、作品介绍和追更入口。具体作品的阅读与付费规则以漫画平台为准，我们会如实标注作品的状态与可读性。',
  },
  {
    id: 'f6',
    q: '如何向编辑推荐自己喜欢的漫画？',
    a: '欢迎通过页面底部的“联系我们”告诉我们你心中的宝藏漫画，编辑部会认真评估并考虑收录进后续的书单推荐。优秀的读者安利有机会成为下一期编辑精选。',
  },
];

export const stats = [
  { label: '编辑精选作品', value: '1200+' },
  { label: '每日更新书单', value: '30+' },
  { label: '活跃追更读者', value: '80万+' },
  { label: '口碑完结神作', value: '400+' },
];

export const categoriesHot = ['热血战斗', '治愈日常', '奇幻冒险', '悬疑推理', '科幻赛博', '恋爱青春'];